import React from 'react';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Services: React.FC = () => {
  const { t } = useTranslation();

  const services = [
    {
      title: t('services.service1.title'),
      description: t('services.service1.description'),
      icon: '📚'
    },
    {
      title: t('services.service2.title'),
      description: t('services.service2.description'),
      icon: '💧'
    },
    {
      title: t('services.service3.title'),
      description: t('services.service3.description'),
      icon: '🏠'
    },
    {
      title: t('services.service4.title'),
      description: t('services.service4.description'),
      icon: '🏥'
    },
    {
      title: t('services.service5.title'),
      description: t('services.service5.description'),
      icon: '👥'
    },
    {
      title: t('services.service6.title'),
      description: t('services.service6.description'),
      icon: '🌱'
    }
  ];

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1 className="page-title">{t('services.title')}</h1>
        </div>
      </div>

      <section className="services-section">
        <div className="container">
          <p className="services-intro">{t('services.intro')}</p>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;









